'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PasswordInput = require('./PasswordInput');

var _PasswordInput2 = _interopRequireDefault(_PasswordInput);

var _BirthdateInput = require('./BirthdateInput');

var _BirthdateInput2 = _interopRequireDefault(_BirthdateInput);

var _PhoneNumberInput = require('./PhoneNumberInput');

var _PhoneNumberInput2 = _interopRequireDefault(_PhoneNumberInput);

var _Checkbox = require('./Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InputDispatcher = function InputDispatcher(props) {
  switch (props.type) {
    case 'hidden':
      return _react2.default.createElement('input', { type: props.type, name: props.name, value: props.value });
    case 'password':
      return _react2.default.createElement(_PasswordInput2.default, props);
    case 'birthdate':
      return _react2.default.createElement(_BirthdateInput2.default, props);
    case 'tel':
      return _react2.default.createElement(_PhoneNumberInput2.default, props);
    case 'checkbox':
      return _react2.default.createElement(_Checkbox2.default, props);
    default:
      return _react2.default.createElement(_Input2.default, props);
  }
};

exports.default = InputDispatcher;